export class ClientDetailsModel {
    clientId: number = 0;
    clientName: string = '';
    defaultCompanyName: string = '';
    defaultCompanyLogo: string = '';
    paymentMode: string = ''; //1->PayNow, 2->PayLater, 3->Both
    theme:string = '';//green-light, orange-light
    beforeBookingTime: string = '';
  }
  